/**
 * Update date: 2025-10-13
 * Screen 2046.G
 */
import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useRef,
} from 'react';
import useAxios from 'axios-hooks';
import { NotFoundPage } from 'app/components/NotFoundPage';
import ArrayStore from 'devextreme/data/array_store';
import LoadPanel from 'app/components/LoadPanel';
import useDictionary from 'hooks/useDictionary';
import useLocalStorage from 'hooks/useLocalStorage';

const List = React.lazy(() => import('./List'));
const CreateUpdate = React.lazy(() => import('./CreateUpdate'));

/**
 * create context
 */
const ReturnDueContext = createContext({
  params: {},
  setParams: () => {},
  refetchData: () => {},
  store: {},
  loadingReturnDue: false,
  modeView: {},
  setModeView: () => {},
});

ReturnDueContext.displayName = 'ReturnDueContext';

export const useReturnDueCenter = () => {
  const context = useContext(ReturnDueContext);
  return context;
};

function ReturnDue() {
  const [dataLocal, setDataLocal] = useLocalStorage('2046.g_mst_dataList', {});
  const { t }: any = useDictionary({
    programId: '2046.G',
  });
  const [params, setParams] = useState({
    fromDate: new Date(),
    toDate: new Date(),
    dataList: {
      store: [],
      zone: [],
    },
    zone: '',
    store: '',
  });
  const [modeView, setModeView] = useState({ type: 'list' });
  const [listDataReturnDue, setListDataReturnDue] = useState<any>([]);
  const dataGridRef: any = useRef(null);
  const [{ data, loading }, refetchData] = useAxios(
    {
      url: '/warehouse/m2046_g_web',
      method: 'POST',
      data: { ...params },
    },
    { manual: true },
  );
  const store: any = new ArrayStore({
    data: listDataReturnDue,
    key: 'returnDueId',
  });

  /**
   * fetch data
   */
  useEffect(() => {
    if (!dataLocal) return;
    setParams(prev => ({
      ...prev,
      dataList: {
        ...prev.dataList,
        zone: dataLocal?.zone || [],
      },
    }));
  }, [dataLocal]);

  useEffect(() => {
    if (data?.data) {
      const dataMapping = (data?.data || []).map(o => {
        o.returnDueStatusNm =
          o?.returnDueStatus === '0' ? t('Pending') : t('Fixed');
        return o;
      });
      setListDataReturnDue(dataMapping);
    }
  }, [data]);


  const value: any = {
    t,
    store,
    params,
    setParams,
    refetchData,
    modeView,
    setModeView,
    setDataLocal,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List ref={dataGridRef} />;
      case 'create':
      case 'edit':
      case 'view':
        return <CreateUpdate />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <ReturnDueContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loading} />
        {renderContent()}
      </React.Suspense>
    </ReturnDueContext.Provider>
  );
}

export default ReturnDue;
